"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellRouterNavigationManager = exports.DocumentTitleChangeEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const web_ui_framework_2 = require("@gruposantander/web-ui-framework");
class DocumentTitleChangeEvent extends web_ui_framework_2.Event {
}
exports.DocumentTitleChangeEvent = DocumentTitleChangeEvent;
class ShellRouterNavigationManager {
    constructor(eventBus, originNavigationManager, flowName) {
        this.eventBus = eventBus;
        this.originNavigationManager = originNavigationManager;
        this.flowName = flowName;
        this.isInternalNavigation = (flow) => {
            const pathSegments = flow.split('/').filter(segment => segment.length > 0);
            if (pathSegments.length > 0) {
                const firstSegment = pathSegments[0];
                return firstSegment === this.flowName;
            }
            return false;
        };
        this.goBack = () => {
            this.originNavigationManager.goBack();
        };
        this.goForward = () => {
            this.originNavigationManager.goForward();
        };
        this.goTo = (flow, data = {}) => {
            if (!this.isInternalNavigation(flow)) {
                const urlParams = {};
                Object.keys(data).forEach(key => {
                    urlParams[key] = data[key].toString();
                });
                this.eventBus.publish('ChangeDocumentTitleEvent', new DocumentTitleChangeEvent({ title: (0, web_ui_framework_1.buildQueryString)(flow, urlParams) }));
            }
            else {
                this.originNavigationManager.goTo(flow, data);
            }
        };
        this.replace = (flow, data = {}) => {
            if (!this.isInternalNavigation(flow)) {
                const urlParams = {};
                Object.keys(data).forEach(key => {
                    urlParams[key] = data[key].toString();
                });
                this.eventBus.publish('ChangeDocumentTitleEvent', new DocumentTitleChangeEvent({ title: (0, web_ui_framework_1.buildQueryString)(flow, urlParams) }));
            }
            else {
                this.originNavigationManager.replace(flow, data);
            }
        };
    }
}
exports.ShellRouterNavigationManager = ShellRouterNavigationManager;
//# sourceMappingURL=shellRouterNavigationManager.js.map